// extracted by css-extract-rspack-plugin
export default {"colorIcon":"d46AS","icon":"WlhwE c1h0N"};